import React, { Component } from 'react';
import networkList from '../../constants/networkList';
import postService from './../../services/httpService';
import { data, isArray } from 'jquery';
import { includes, update } from 'ramda';
const $ = require('jquery');

class Counsellor_display extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tableData: [],
            blinkArray: [],
            renderType: ''
        }
    }

    componentDidMount() {
        const params = new URLSearchParams(this.props.location.search);
        const csid = params.get('csid');

        if (csid !== undefined && csid !== null && csid !== '') {
            this.renderBodydata(csid,'init');
            // call getTVdisaplayTokenswithNoAuth every 8s

            this.interval = setInterval(() => { this.renderBodydata(csid,'second') }, 15000);
        }
        this.speechText('init');
    }

    componentDidUpdate(prevProps, prevState){    
        // checking the blinkArray is update
        if(this.state.renderType === 'second'){         
        if (prevState.blinkArray.length >0 && this.state.blinkArray.length >0) {          
            this.speechText('didupdate');
        }else {
            console.log('enter to didupdate else No blinkarray')
        }
    }else {
        console.log('renderType:',this.state.renderType)
    }
    }


    componentWillUnmount() {
        clearInterval(this.interval);
        $('footer').css({ 'position': 'relative', top: 'unset' });
        console.log('....unmount')
        this.state = {            
            tableData: []
        }
    }

    renderBodydata(id,type) {
        localStorage.getItem('user_data');
        let user_data = null;
        if (localStorage.getItem('user_data')) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        let { getTVdisaplayTokenswithNoAuth } = networkList;

        let {blinkArray} = this.state
        
        postService(getTVdisaplayTokenswithNoAuth, 'POST', { "data": { "counselling_station_id": id } }).then((res) => {            
            if (res.status) {
                if (Array.isArray(res['data']) && res['data'].length !== 0) {
                   let { tableData } = this.state;
                   let exists_counselled = tableData.map(function (el) { return el.counselled_by; });
                   
                    // res['data'].sort(function(a, b){return parseInt(a['counselled_by'])- parseInt(b['counselled_by'])})
                    res['data'].sort(function(a, b){
                        if(a.counsellor_name < b.counsellor_name) { return -1; }
                        if(a.counsellor_name > b.counsellor_name) { return 1; }
                        return 0;
                     })
                 res['data'].map((data,key)=>{                       
                     if(!exists_counselled.includes(data['counselled_by'])) {
                         res['data'][key]['blink_sound'] = 'show_blink';
                         blinkArray.push(res['data'][key])
                     }else{
                         console.log('all !exists else')
                     }
                     tableData.map((tdata,tkey)=>{
                            if(data['counselled_by'] === tdata['counselled_by'] && data['token_display_id'] !== tdata['token_display_id']){                              
                                // show blink for new tokens
                                res['data'][key]['blink_sound'] = 'show_blink';
                                blinkArray.push(res['data'][key])                                                              
                            }else if(data['counselled_by'] === tdata['counselled_by'] && data['token_display_id'] === tdata['token_display_id'] && data['recall'] !== tdata['recall']){
                                // show blink for recall tokens
                                res['data'][key]['blink_sound'] = 'show_blink';
                                blinkArray.push(res['data'][key])                            
                            }else {                                
                                console.log('else')
                            }
                        })
                    })

console.log(res['data'],tableData);

                    this.setState((state) => ({
                        'tableData': res['data'],
                        'blinkArray': blinkArray ? blinkArray : [],
                        'renderType': type
                    }))
                    
                }else{
                    this.setState((state) => ({
                        'tableData': []
                    }))
                }                
            }
        })
    }

// sleep function
sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds));
  }
// call sleep by async
delayed = async (ms) => {
    await this.sleep(ms);        
  }
// deleting the 1st object in blink array
deleting = async (blinkArray) => {
    return new Promise((resolve, reject) => {
        if(blinkArray && Array.isArray(blinkArray) && blinkArray.length !=0 ) { 
            blinkArray.splice(0,1)
            resolve(blinkArray);                
         }else {
             console.log('no deleting obj')
             resolve('');
         }            
    })       
}
// call the speechtext each object sync,3times with delay
speechText = async (type) => {          
    // console.log(type)        
    let { blinkArray } = this.state;
        if(blinkArray && Array.isArray(blinkArray) && blinkArray.length !=0 ) {                                                              
            let i = blinkArray.length
            let blinkLength = blinkArray.length
            for (const data of blinkArray) {
                let key = i;                   
                var audio = new Audio('/assets/announcement.mp3');
                audio.play();
                // call 3times                                 
                await this.callToken(data, key);
                await this.callToken(data, key);  
                await this.callToken(data, key); 
                // delete 1st object
                blinkArray = await this.deleting(blinkArray);
                // delay 5s
                await this.delayed(40000)                                                       
            }                          
        }else {                    
             console.log('blink array is empty')
        }  
        
       
                        
    
}

callToken_oldone = async (data, key) => {
    // console.log('callToken enter')
    setTimeout(async() => {
        try {
            var synthesis = window.speechSynthesis;
            if ('speechSynthesis' in window) {
                var synthesis = window.speechSynthesis;
                var voice = []
                
                    voice = window.speechSynthesis.getVoices().filter(function (voice) {
                        return voice.lang === 'en-US';
                    });

                    // var utterance = new SpeechSynthesisUtterance(`Token Number ${data ? data.token_display_id : null}`);

                    // Set utterance properties
                    // utterance.voice = voice[2];
                    // utterance.pitch = 1;
                    // utterance.rate = 1;
                    // utterance.volume = 1;
                    // adding blink css
                    var element = document.getElementById('a'+data.id);
                    element.classList.add("blink_me");
                    var element2 = document.getElementById('b'+data.id);
                    element2.classList.add("blink_me");
                    var element2 = document.getElementById('c'+data.id);
                    element2.classList.add("blink_me");
                    var element3 = document.getElementById('d'+data.id);
                    element3.classList.add("blink_me");
                    // speech    
                    // synthesis.speak(utterance);
                    // add delay 6s
                    await this.delayed(6000)
                    // remove blink css
                    var element = document.getElementById('a'+data.id);
                    element.classList.remove("blink_me");
                    var element2 = document.getElementById('b'+data.id);
                    element2.classList.remove("blink_me");
                    var element2 = document.getElementById('c'+data.id);
                    element2.classList.remove("blink_me");
                    var element3 = document.getElementById('d'+data.id);
                    element3.classList.remove("blink_me");
                            
            } else {
                console.log('Text-to-speech not supported.');
            }
        } catch (error) {
            console.log(error);
        }
        return Promise.resolve(true)
    },10)
}

callToken = async (data, key) => {
    // console.log('callToken enter',data ,key)
    setTimeout(async () => {
      try {
        const collection = document.getElementsByClassName(`a${data.id}`);
        let len = collection.length ? collection.length : 0;
        for (let i = 0; i < len; i++) {
          collection[i].classList.add("blink_me");
       }
       await this.delayed(6000);
        for (let i = 0; i < len; i++) {
          collection[i].classList.remove("blink_me");
        }
      } catch (error) {
        console.log(error);
      }
      return Promise.resolve(true);
    }, 10);
  };
    render() {
        let { tableData } = this.state;
        return (
            <div>

                <div className="tv-counter-data">
                    <div className="py-3 counter-card h-100 col-12">
                        <div className="row">
                            <div className="col-12">
                                <div className="col-12 reports-details counter-details">
                                    <div className="card">
                                        <table>
                                            <thead>
                                                <tr className="row head-row">
                                                    {/* <th className="col-3 my-auto">Doctor</th> */}
                                                    <th className="my-auto"  style={{width:'50%'}}>Patient Name</th>
                                                    <th className="my-auto" style={{width:'20%'}}>Token</th>
                                                    <th className="my-auto" style={{width:'30%'}}>Cabin Name</th>
                                                    {/* <th className="my-auto" style={{width:'30%'}}>Department Name</th> */}
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                    <div className="card">
                                        <table className="table-body">
                                            <tbody>
                                                {tableData.map((data, key) => {
                                                    return (<tr className="row tv-row" >
                                                    <td className={`my-auto order-1 a${data.id}`} id={'a'+data.id}  style={{width:'50%'}}>{data.patient_name.length>30?data.patient_name.substring(0, 30)+ "..":data.patient_name}</td>
                                                    <td className={`my-auto order-1 a${data.id}`} id={'c'+data.id} style={{width:'20%'}}><div className="token">{data.current_token_count}</div> </td> 
                                                    <td className={`my-auto order-1 a${data.id}`} id={'b'+data.id} style={{width:'30%'}}>{data.cabin_name}</td>                                                                                                      
                                                    
                                                    {/* <td className={'my-auto order-1'} id={'d'+data.id } style={{width:'30%'}}><div >{data.department_name.length>13?data.department_name.substring(0, 13) + "..":data.department_name}</div></td> */}
                                                  
                                                </tr>);
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
 {/* New div at the bottom of the screen */}
 <div className="footer-text">
        <p style={{marginTop: '8px'}}>Grievance Number : 9091922233   |   Email : grievance@kimshospitals.com</p>
    </div>
            </div>

        )
    }
}

export default Counsellor_display;